import { Trans } from '@exam-room/translations';
import { cn } from '@exam-room/utils';
import { useEffect, useState } from 'react';

import { CloseRoundedIcon, ErrorRoundedIcon } from '../../../components';
import { useExamEvent, useExamSession, useServerTime } from '../../../providers';

export default function TimerAlert() {
  const [visible, setVisible] = useState(true);
  const [shouldShow, setShouldShow] = useState(false);

  const { closestExam } = useExamEvent();
  const { examSession } = useExamSession();
  const { timeOffset } = useServerTime();

  const endedAt = examSession?.endedAt;
  const endedAtDate = new Date(endedAt ?? new Date());

  const endDate = closestExam?.endedAt ?? endedAtDate;

  useEffect(() => {
    const checkTime = () => {
      const now = new Date().getTime() + timeOffset;
      const diff = endDate.getTime() - now;
      const minutesLeft = diff / (1000 * 60);
      setShouldShow(minutesLeft <= 10 && minutesLeft > 0);
    };

    checkTime();
    const interval = setInterval(checkTime, 1000);
    return () => clearInterval(interval);
  }, [endDate]);

  return (
    <div
      className={cn(
        'transition-[opacity,transform,height] duration-500 ease-in-out',
        visible && shouldShow
          ? 'h-auto translate-y-0 opacity-100'
          : 'pointer-events-none h-0 -translate-y-4 overflow-hidden opacity-0',
      )}
    >
      <div
        className={cn(
          visible && shouldShow && 'mb-6 px-4 py-3',
          'bg-danger-100 text-danger-900 flex items-center justify-between gap-3 rounded-lg',
        )}
      >
        <div className='flex items-center gap-3'>
          <ErrorRoundedIcon className='text-danger shrink-0' />
          <div className='text-md font-normal'>
            <Trans
              i18nKey='examRoom.timeRemainingWarning'
              values={{ minutes: 10 }}
              components={{
                strong: <span className='font-semibold' />,
              }}
            />
          </div>
        </div>
        <CloseRoundedIcon
          className='shrink-0 cursor-pointer text-gray-600'
          onClick={() => setVisible(false)}
        />
      </div>
    </div>
  );
}
